import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const StrictModeWrapper =
  process.env.NODE_ENV === "development" ? React.Fragment : React.StrictMode;

console.log(`app running in ${process.env.NODE_ENV} mode`);

root.render(
  <StrictModeWrapper>
    <App />
  </StrictModeWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
